import { useState } from 'react';
import { Seal } from './views/Seal';
import { Open } from './views/Open';
import { Storage } from './views/Storage';
import { loadConnection } from './lib/providers';

type Tab = 'seal' | 'open' | 'storage';

export function App() {
  const [tab, setTab] = useState<Tab>('seal');
  const [conn, setConn] = useState(loadConnection());

  const connected = !!conn?.verifiedAt;

  return (
    <main className="wrap">
      <header className="masthead">
        <div className="mark">AG</div>
        <h1>
          Encrypt it here. <em>Keep it yours.</em>
        </h1>
        <p className="lede">
          Your documents are encrypted in this tab and stored where you choose.
          No account, no upload to us — there is no server on this page.
        </p>
      </header>

      <nav className="tabs">
        <button className={tab === 'seal' ? 'on' : ''} onClick={() => setTab('seal')}>
          Protect a document
        </button>
        <button className={tab === 'open' ? 'on' : ''} onClick={() => setTab('open')}>
          Open an envelope
        </button>
        <button className={tab === 'storage' ? 'on' : ''} onClick={() => setTab('storage')}>
          Storage{connected ? ' ·' : ''}
        </button>
      </nav>

      {tab === 'seal' && <Seal />}
      {tab === 'open' && <Open />}
      {tab === 'storage' && <Storage onChange={() => setConn(loadConnection())} />}

      <footer>
        <strong>Nothing on this page is sent to us.</strong> Encryption and your
        storage keys stay in this browser. Your passphrase is never stored — if
        you lose it, nobody can recover the document, including us.
      </footer>
    </main>
  );
}
